/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 */
import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import radioButtonTemplate from '../template/radio-button.hbs';
import radioSwitchTemplate from '../template/radio-switch.hbs';
import BSSPackageValidation from '@main/externals/bss-package-validation/js/bss-package-validation.js';
import logger from '@main/externals/bss-package-logger/js/logger';
var radioButtonTemplates = {
    defaultTemplate: radioButtonTemplate,
    radioSwitchTemplate: radioSwitchTemplate,
};
/**
 * BSSRadioButtonComponent class
 */
var BSSRadioButtonComponent = /** @class */ (function (_super) {
    __extends(BSSRadioButtonComponent, _super);
    /**
     * @listens {bss-entity-created-$entityId} - listens when entity is rendered completely
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [EventManager=null] instance of _EventManager
     * @param {Formatter} [Formatter=null] instance of Formatter
     * @param {Resolution} [Resolution=null] Resolution class for width breakpoint handling
     * @param {object} [toolbox=null] provides common libraries: jquery and lodash
     */
    function BSSRadioButtonComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, radioButtonTemplates, toolbox) || this;
        /**
         * @private method
         * @desc refer to storybook Radio button/Associated Radio Buttons notes
         */
        _this._updateAssociatedErrorsVisibility = function () {
            logger.info('BSSRadioButtonComponent: ' +
                _this._config.componentId +
                ' => function : _updateAssociatedErrorsVisibility');
            if (_this._config.associatedErrorIds) {
                var watcherClass = 'bss-watcher-hide';
                var isSomeAssociatedAgreementIsYes = _this._isSomeAssociatedRadioIsYes('agreement');
                var isSomeAssociatedTargetIsYes = _this._isSomeAssociatedRadioIsYes('target');
                var _a = _this._config.associatedErrorIds || {}, _b = _a.target, target = _b === void 0 ? '#targetValidationError' : _b, _c = _a.agreement, agreement = _c === void 0 ? '#agreementValidationError' : _c;
                var $targetErrorEl = _this._entityTemplate.find(target);
                var $agreementErrorEl = _this._entityTemplate.find(agreement);
                // Reset all errors first
                $targetErrorEl.addClass(watcherClass);
                $agreementErrorEl.addClass(watcherClass);
                if (isSomeAssociatedTargetIsYes && !isSomeAssociatedAgreementIsYes) {
                    $targetErrorEl.removeClass(watcherClass);
                }
                else if (isSomeAssociatedAgreementIsYes &&
                    !isSomeAssociatedTargetIsYes) {
                    $agreementErrorEl.removeClass(watcherClass);
                }
                _this._radioButtonInput.closest('form').trigger('change');
            }
        };
        /**
         * @param {Event} ev event object
         * @private
         */
        _this._prepareClickedRadioDataForTagging = function (ev) {
            var _a;
            logger.info('BSSRadioButton ' +
                _this._config.componentId +
                ' => function : _prepareClickedRadioDataForTagging | Params', ev);
            var productId = _this.getProductId();
            var eventTarget = _this._toolbox.$(ev.currentTarget);
            var clickedValue = eventTarget.attr('value');
            var clickedComponentId = eventTarget.attr('id');
            var checked = "".concat(clickedComponentId, "_").concat(eventTarget[0].checked);
            var previousRadioDataCheckedValue = ((_a = eventTarget.attr('data-checked')) === null || _a === void 0 ? void 0 : _a.split('.').pop()) || null;
            var previousValue = _this._config.resultData[productId][previousRadioDataCheckedValue] ||
                _this._clickedRadioData.previousValue;
            var previousChecked = _this._clickedRadioData.previousChecked;
            _this._clickedRadioData = {
                checked: checked,
                previousChecked: previousChecked,
                previousValue: previousValue,
                clickedValue: clickedValue,
                clickedComponentId: clickedComponentId,
            };
        };
        _this._componentVersion = '@@name ver. @@version';
        logger.info('BSSRadio Button ' +
            _this._config.componentId +
            ' has been successful render');
        /**
         * @desc contains referens to all radio wrappers from the same radio group, it is set when entity is created
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$radioGroupWrappers = null;
        /**
         * @desc components radio
         * @private
         * @type {jQuery|HTMLElement}
         */
        _this._$radioBtn = _this._componentTemplate.find('#' + _this._config.componentId + '_rbtn');
        /**
         * @desc radio parent wrapper
         * @private
         * @type {jQuery|HTMLElement}
         */
        _this._$radioParent = _this._$radioBtn.parent('.bss-radio-button, .bss-radio-switch_item');
        /**
         * @desc radio button price
         * @private
         * @type {jQuery|HTMLElement}
         */
        _this._$radioPrice = _this._$radioParent.find('.bss-radio-button_price');
        /**
         * @desc stores all inputs from group
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._groupRadios = null;
        /**
         * @desc jQuery reference to radio input element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._radioButtonInput = _this._componentScope.find('input[type=radio]');
        /**
         * @desc jQuery reference to radio target element
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._$radioInputTarget = _this._componentScope.find('.bss-radio-button_cxb-target');
        /**
         * @desc clicked radio data object needed for tagging
         * @type {object}
         * @private
         */
        _this._clickedRadioData = {};
        /**
         * Class added on radio trigger element when it is pressed
         * @type {string}
         * @private
         */
        _this._pressedClass = 'bss-radio-button-pressed';
        if (_this._config.hintText) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._validationSettings = _this._toolbox._.merge({}, {
            componentId: "".concat(_this._config.componentId, "_container_validator"),
            validation: {
                additionalHideErrors: '',
                ajaxValidation: false,
                defaultErrors: true,
                formSelector: '#form',
                throwEventOnError: '',
                throwEventOnSuccess: '',
            },
        }, _this._config.validationSettings);
        if (_this._validationSettings) {
            _this._validation = new BSSPackageValidation(_this._validationSettings, toolbox, eventManager);
        }
        _this._addEventListeners();
        _this._addRadioEvents();
        _this._hidePrice();
        return _this;
    }
    /**
     * Add all component event listeners
     * @private
     */
    BSSRadioButtonComponent.prototype._addEventListeners = function () {
        this._window.on('resize.' + this._config.componentId, this._calculateInfohintPosition.bind(this));
        this._eventManager.subscribe('bss-fonts-ready-' + this._config.entityInstanceId, this._calculateInfohintPosition.bind(this), this.subscriberPrefix + this._config.componentId, true);
        this._eventManager.subscribe('bss-watcher-show-' + this._config.entityInstanceId, this._calculateInfohintPosition.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-component-data-rebound-' + this._config.componentId, this._hidePrice.bind(this), this.subscriberPrefix + this._config.componentId);
        this._manageEvents();
    };
    /**
     * Add radio element events
     * @private
     */
    BSSRadioButtonComponent.prototype._addRadioEvents = function () {
        this._radioButtonInput.on('click.' + this._config.componentId, this._updateAssociatedErrorsVisibility);
        this._radioButtonInput.on('click.' + this._config.componentId, this._prepareClickedRadioDataForTagging);
        this._addPressedRadioEvent();
    };
    /**
     * Add active(pressed) radio state for additional 'active' styling
     * @private
     */
    BSSRadioButtonComponent.prototype._addPressedRadioEvent = function () {
        var _this = this;
        // Start press
        ['mousedown', 'touchstart'].forEach(function (event) {
            _this._$radioInputTarget.on(event, function (_a) {
                var currentTarget = _a.currentTarget;
                _this._toolbox.$(currentTarget).addClass(_this._pressedClass);
            });
        });
        // End press
        ['mouseup', 'touchend'].forEach(function (event) {
            _this._$radioInputTarget.on(event, function (_a) {
                var currentTarget = _a.currentTarget;
                _this._toolbox.$(currentTarget).removeClass(_this._pressedClass);
            });
        });
    };
    /**
     * @private method
     * @desc calculate infohint position
     */
    BSSRadioButtonComponent.prototype._calculateInfohintPosition = function () {
        logger.info('BSSRadioButtonComponent: ' +
            this._config.componentId +
            ' => function : _calculateInfohintPosition');
        var calculatePosition = typeof this._config.removeInfohintCalculatedPosition === 'undefined' ||
            !this._config.removeInfohintCalculatedPosition;
        if (this._$radioParent.find('.bss-radio-button_infohint').length &&
            calculatePosition) {
            this._$radioParent.find('.bss-radio-button_infohint').css({
                left: this._$radioParent.find('.bss-radio-button-label').outerWidth() -
                    parseInt(this._$radioParent
                        .find('.bss-radio-button-label')
                        .css('padding-right')) +
                    5 +
                    'px',
            });
        }
    };
    /**
     * @private method
     * @desc check value price
     */
    BSSRadioButtonComponent.prototype._hidePrice = function () {
        logger.info('BSSRadioButtonComponent: ' +
            this._config.componentId +
            ' => function : _hidePrice');
        if (this._$radioPrice &&
            this._$radioPrice.hasClass('bss-radio-button_price--is-hidden')) {
            this._$radioPrice.removeClass('bss-radio-button_price--is-hidden');
        }
        if (this._config.price) {
            var price = parseFloat(this._getValue(this._config.price));
            if (isNaN(price) || price < 0) {
                this._$radioPrice.addClass('bss-radio-button_price--is-hidden');
            }
        }
    };
    /**
     * @desc subscribe/unsubscribe to all events
     * @private
     */
    BSSRadioButtonComponent.prototype._manageEvents = function () {
        logger.info('RadioButtonComponent: ' +
            this._config.componentId +
            ' => function : _manageEvents');
        this._eventManager.subscribe('bss-entity-created-' + this._config.entityInstanceId, this._getRadioGroup.bind(this), this.subscriberPrefix + this._config.componentId);
        if (this._config.unselectable) {
            this._inputs
                .filter('input[type="radio"]')
                .off('change.' + this._config.componentId);
            this._inputs
                .filter('input[type="radio"]')
                .on('click.' + this._config.componentId, this._onClick.bind(this));
        }
    };
    /**
     * @emits {bss-radio-group-created-GROUPNAME-created} emits event when radio group object is created
     * @private
     * @desc get group of radio's
     */
    BSSRadioButtonComponent.prototype._getRadioGroup = function () {
        logger.info('BSSRadioButton ' +
            this._config.componentId +
            ' => function : _getRadioGroup');
        this._setRadioGroupDefaults();
        this._eventManager.publish("bss-radio-group-created-".concat(this._config.groupName), "radioGroup-".concat(this._config.groupName));
    };
    /**
     * @desc defines radio group defaults
     * @private
     */
    BSSRadioButtonComponent.prototype._setRadioGroupDefaults = function () {
        this._groupRadios = this._entityTemplate.find('[name="' + this._config.groupName + '"]');
        this._$radioGroupWrappers = this._groupRadios.parent('.bss-radio-button, .bss-radio-switch_item');
        this._$radioGroupWrappers.addClass('bss-radio-button-group-' + this._config.groupName);
    };
    /**
     * @param associatedRole {'target' | 'agreement'} associated role of the radio button:
     * 'target' - should be selected to allow selection of some 'agreement'
     * 'agreement' - can not be selected until some 'target' is selected
     * @returns {boolean}
     * @private
     */
    BSSRadioButtonComponent.prototype._isSomeAssociatedRadioIsYes = function (associatedRole) {
        var _a;
        logger.info('BSSRadioButton ' +
            this._config.componentId +
            ' => function : _isSomeAssociatedRadioIsYes');
        return !!((_a = this._entityTemplate.find("input[data-associated-".concat(associatedRole, "=\"true\"][type=radio][value=\"yes\"]:checked"))) === null || _a === void 0 ? void 0 : _a.length);
    };
    /**
     * @override
     * @desc
     * @param {Event} ev
     * @emits {bss-radio-button-group-GROUPNAME-change} emit event when there is change on group
     * @private
     */
    BSSRadioButtonComponent.prototype._onInputChange = function (ev) {
        logger.info('BSSRadioButton ' +
            this._config.componentId +
            ' => function : _onInputChange | Params', ev);
        this._$radioGroupWrappers.removeClass('checked');
        _super.prototype._onInputChange.call(this, ev);
        this._eventManager.publish('bss-radio-button-group-' + this._config.groupName + '-change', 'radio-group-' + this._config.groupName);
        if (this._config.isOA && this._toolbox.$(ev.currentTarget).prop('required'))
            this._eventManager.publish('bss-step-navigation-on-form-change-' + this._config.entityInstanceId, 'radio-group-' + this._config.groupName, { valid: this._validation.isValid(true, false) });
    };
    /**
     * @desc method called on click in radio, method used only with unselectable option
     * @private
     */
    BSSRadioButtonComponent.prototype._onClick = function () {
        logger.info('BSSRadioButton ' + this._config.componentId + ' => function : _onClick');
        //this class means that radio was checked earlier
        var resultDataObj = {};
        if (this._$radioParent.hasClass(this._checkedClass)) {
            this._$radioGroupWrappers.removeClass(this._checkedClass);
            this._formElementsWrapper.removeClass(this._checkedClass);
            this._$radioBtn.prop('checked', false);
            resultDataObj[this._outputObject.checked] = this._config.unselectedValue;
        }
        else {
            this._$radioGroupWrappers.removeClass(this._checkedClass);
            this._formElementsWrapper.addClass(this._checkedClass);
            resultDataObj[this._outputObject.checked] = this._$radioBtn.val();
        }
        this._eventManager.publish('bss-radio-button-group-' + this._config.groupName + '-change', 'radio-group-' + this._config.groupName);
        this._onOutputChange(resultDataObj);
    };
    /**
     * @private
     */
    BSSRadioButtonComponent.prototype._hasRadioChangedValue = function () {
        logger.info('BSSRadioButton: ' +
            this._config.componentId +
            ' => function : _hasRadioChangedValue');
        var _a = this._clickedRadioData || {}, clickedValue = _a.clickedValue, previousValue = _a.previousValue, previousChecked = _a.previousChecked, checked = _a.checked;
        if (this._config.unselectable) {
            return !!(previousChecked !== checked || clickedValue !== previousValue);
        }
        return !!(clickedValue &&
            previousValue &&
            (clickedValue !== previousValue || previousValue === undefined));
    };
    /**
     * @desc trigger abstract _triggerTagging functionality for the clicked radio if radio changed its value
     * @override
     */
    BSSRadioButtonComponent.prototype._triggerTagging = function () {
        var _a;
        logger.info('BSSRadioButton: ' +
            this._config.componentId +
            ' => function : _triggerTagging');
        // check if we work with the currently clicked radio, not with the sibling ones
        if (((_a = this._clickedRadioData) === null || _a === void 0 ? void 0 : _a.clickedComponentId) === this._$radioBtn.attr('id')) {
            var hasRadioChangedValue = this._hasRadioChangedValue();
            // check if the clicked radio has changed value, then trigger tagging
            if (hasRadioChangedValue) {
                _super.prototype._triggerTagging.call(this);
            }
            // do not clear previousValue to keep it for future assignment in _prepareClickedRadioDataForTagging
            // (when the value is not present from the last resultData when e.g we keep on clicking at least twice the same checked radio)
            this._clickedRadioData.clickedComponentId = null;
            this._clickedRadioData.clickedValue = null;
            this._clickedRadioData.previousChecked = this._clickedRadioData.checked;
        }
    };
    /**
     *
     * @public method
     * @desc destroys infohint and call super method
     */
    BSSRadioButtonComponent.prototype.destroy = function () {
        logger.info('BSSRadioButton ' + this._config.componentId + ' => function : destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSRadioButtonComponent;
}(BSSAbstractComponent));
export default BSSRadioButtonComponent;
